import { RouteProps } from '../../routes/AppRouter'
import { Title } from 'components/common/Title'
import { PatientsInmunocomDetail } from 'features/patients'

export function Detail(props: RouteProps) {
  return (
    <>
      <Title color={props.color} title={props.title || ''} />
      <PatientsInmunocomDetail id={props.id} />
    </>
  )
}
